import { FastCheckoutActionTypes } from './fastcheckout.types';

const requestFastCheckoutProduct = ({
  coupon, billingCycle, pid,
}) => ({
  type: FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PRODUCT,
  payload: {
    billingCycle, coupon, pid,
  },
});
const requestFastCheckoutProductFailure = () => ({ type: FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PRODUCT_FAILURE });
const requestFastCheckoutProductSuccess = () => ({ type: FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PRODUCT_SUCCESS });
const setFastCheckoutProduct = product => ({ type: FastCheckoutActionTypes.SET_FAST_CHECKOUT_PRODUCT, payload: { product } });

const setFastCheckoutLoading = loading => ({ type: FastCheckoutActionTypes.SET_FASTCHECKOUT_LOADING, payload: { loading } });

const requestFastCheckoutPurchase = ({
  discount, product, paymentMethod, onSuccessCallback,
}) => ({
  type: FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PURCHASE,
  payload: {
    discount, product, paymentMethod, onSuccessCallback,
  },
});
const requestFastCheckoutPurchaseSuccess = () => ({ type: FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PURCHASE_SUCCESS });
const requestFastCheckoutPurchaseFailure = () => ({ type: FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PURCHASE_FAILURE });
const requestFastCheckoutSetError = error => ({ type: FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PURCHASE_SET_ERROR, payload: { error } });

const fastCheckoutReset = () => ({ type: FastCheckoutActionTypes.FASTCHECKOUT_RESET });

const actions = {
  product: {
    request: requestFastCheckoutProduct,
    failure: requestFastCheckoutProductFailure,
    success: requestFastCheckoutProductSuccess,
    set: setFastCheckoutProduct,
  },
  purchase: {
    request: requestFastCheckoutPurchase,
    success: requestFastCheckoutPurchaseSuccess,
    failure: requestFastCheckoutPurchaseFailure,
    setError: requestFastCheckoutSetError,
  },
  loading: setFastCheckoutLoading,
  reset: fastCheckoutReset,
};

export default actions;
